interface CharacterCounterProps {
    current: number;
    max: number;
}

export function CharacterCounter({ current, max }: CharacterCounterProps) {
    const charsLeft = max - current;
    const isOverLimit = charsLeft < 0;
    const isWarning = charsLeft <= 20;
    const showNumber = charsLeft <= 50;

    // Calculate progress (capped at 100%)
    const progress = Math.min(current / max, 1);

    // Circle properties
    const radius = 9;
    const circumference = 2 * Math.PI * radius;
    const strokeDashoffset = circumference * (1 - progress);

    // Color based on state
    const strokeColor = isOverLimit
        ? '#FF4D4D'
        : isWarning
            ? '#FFD700'
            : '#A38BFF';

    const textColor = isOverLimit
        ? 'text-[#FF4D4D]'
        : isWarning
            ? 'text-[#FFD700]'
            : 'text-[#A7B0C8]';

    return (
        <div className="flex items-center gap-2">
            {showNumber && (
                <span className={`text-xs font-medium tabular-nums ${textColor}`}>
                    {charsLeft}
                </span>
            )}
            <svg width="24" height="24" className="rotate-[-90deg]">
                {/* Background circle */}
                <circle
                    cx="12"
                    cy="12"
                    r={radius}
                    fill="none"
                    stroke="#2A2F3A"
                    strokeWidth="2.5"
                />
                {/* Progress circle */}
                <circle
                    cx="12"
                    cy="12"
                    r={radius}
                    fill="none"
                    stroke={strokeColor}
                    strokeWidth="2.5"
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round"
                    style={{ transition: 'stroke-dashoffset 0.1s ease' }}
                />
            </svg>
        </div>
    );
}